import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { AlertStackComponent } from './components/alert-stack/alert-stack.component'
import { SpinnerComponent } from './components/spinner/spinner.component'
import { ToastStackComponent } from './components/toast-stack/toast-stack.component'

@Component({
  selector: 'gpei-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.sass'],
  standalone: true,
  imports: [
    SpinnerComponent,
    AlertStackComponent,
    ToastStackComponent,
    RouterOutlet
  ]
})
export class AppComponent {}
